// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"s_-z","subtitle":"t_-z","wrapper":"u_-z","leftArrow":"v_-z","rightArrow":"w_-z"};